import { useCallback } from "react"
import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { TokenStore } from "@/domains/tokens"
import { TokenInputCard } from "@/domains/tokens/components/token-input-card"

interface ZapInputFormProps {
  store: ZapStore
  tokens: Array<TokenStore>
}

export const ZapIdle = observer(({ store, tokens }: ZapInputFormProps) => {
  const handleAmountChange = useCallback(
    (amount: string) => {
      if (!store.zapToken) return
      store.setInputAmount(amount)
    },
    [store],
  )

  return (
    <TokenInputCard
      amount={store.displayInputAmount}
      token={store.zapToken}
      tokens={tokens}
      onTokenAmountChange={handleAmountChange}
      onTokenSelect={(token: TokenStore | null) => {
        if (token) {
          store.setUiZapToken(token)
        } else {
          store.clearUiZapToken()
        }
      }}
      showTokenSelectable={true}
      showTokenSymbol={false}
    />
  )
})
